// api.js
import { fetchAsyncEditFormOptions } from 'redux/formOptions';
import { fetchAsyncGetMinorSubCategory } from 'redux/formOptions';
import { fetchAsyncEditSubCategory } from 'redux/formOptions';
import { fetchAsyncDeleteMinorSubCategory } from 'redux/formOptions';
import { fetchAsyncEditMinorSubCategory } from 'redux/formOptions';
import { fetchAsyncCreateMinorSubCategory } from 'redux/formOptions';
import { fetchAsyncDeleteSubCategory } from 'redux/formOptions';
import { fetchAsyncCreateSubCategory } from 'redux/formOptions';
import { fetchAsyncGetSubCategory, fetchAsyncDeleteFormOptions, fetchAsyncAddValueToFormOptions } from 'redux/formOptions';
import Swal from 'sweetalert2';

const showSuccessAlert = (payload) => {
    Swal.fire({
      title: "Successfully Added",
      icon: "success",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ok",
      customClass: {
        container: "sweet_containerImportant",
        confirmButton: "sweet_confirmbuttonImportant",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // console.log(payload);
      }
    });
  };
  
  const showErrorAlert = () => {
    Swal.fire({
      title: "Something went wrong",
      icon: "warning",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      customClass: {
        container: "sweet_containerImportant",
        confirmButton: "sweet_confirmbuttonImportant",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // console.log(result);
      }
    });
  };

  export const createFormOptionApi = async (data, type, dispatch, expenseType) => {
    try {
      const res = await dispatch(
        fetchAsyncAddValueToFormOptions({
          label: data.label,
          value: data.value,
          type,
          expenseType,
        })
      );
  
      if (res.payload.val) {
        const setData = {
          label: res.payload.lab,
          value: res.payload.val,
          id: res.payload?._id,
        };
        showSuccessAlert();
        return setData;
      }
    } catch (err) {
      showErrorAlert();
      return null; 
    }
  };
  
  export const deleteFromOptionApi = (dispatch, _id) => {
    if (_id) {
      return dispatch(fetchAsyncGetSubCategory(_id)).then((response) => {
        if (response.payload) {
          const minorOption = response.payload || [];
          if (minorOption.length > 0) {
            return { success: false, message: 'Please delete all related Minor Type first' };
          } else {
            return dispatch(fetchAsyncDeleteFormOptions(_id)).then((res) => {
              return { success: true, message: 'Option deleted successfully!' };
            });
          }
        }
      });
    }
    return Promise.resolve({ success: false, message: 'No ID provided' });
  };

  export const editFromOptionApi = async (dispatch,_id,newValue, expenseType) => {
    if (_id) {
      try {
        const res = await dispatch(fetchAsyncEditFormOptions({
          id: _id,
          newData: {
            optionValue: newValue,
            expenseType: expenseType,
          },
        }));

        if (res.payload.val) {
          const setData = {
            label: res.payload.lab,
            value: res.payload.val,
            id: res.payload._id,
          };
          return { success: true, data: setData };
        }
      } catch (err) {

        return { success: false, message: 'Error editing option' };
      }
    }
    return { success: false, message: 'No ID provided' };
  };


  export const createSubCategoryApi = async (dispatch, optionId, category,expenseType) => {
    try {
      const res = await dispatch(fetchAsyncCreateSubCategory({ id: optionId, category, expenseType }));
      if (res.payload && res.payload.val) {
        return {
          success: true,
          data: {
            id: res.payload._id,
            label: res.payload.lab,
            value: res.payload.val,
            expenseType: res.payload?.expTyp,
            ...res.payload,
          },
        };
      }
    } catch (error) {
      return { success: false, message: 'Error creating subcategory' };
    }
    
    return { success: false, message: 'Failed to create subcategory' };
  };

  export const deleteSubCategoryApi = async (dispatch, id) => {
    try {
      const response = await dispatch(fetchAsyncGetMinorSubCategory(id));
      
      if (response.payload) {
        const minorSubOption = response.payload || [];
  
        if (minorSubOption.length > 0) {
          return { success: false, message: 'Please delete all related Minor Sub Category first' };
        } else {
          const deleteResponse = await dispatch(fetchAsyncDeleteSubCategory(id));
          if (deleteResponse.payload && deleteResponse.payload.val) {
            return { success: true, value: deleteResponse.payload.val };
          }
        }
      }
    } catch (error) {
      return { success: false, message: 'Error deleting subcategory' };
    }
  
    return { success: false, message: 'Failed to delete subcategory' };
  };

  export const editSubCategoryApi = async (dispatch, _id, newValue,expenseType) => {
    try {
      const res = await dispatch(fetchAsyncEditSubCategory({
        id:_id,
        newData: {
          optionValue: newValue,
          expenseType,
        },
      }));
  
      if (res.payload && res.payload.val) {
        return { success: true, id: _id };  
      }
    } catch (error) {
      return { success: false, message: 'Error editing subcategory' };
    }
  
    return { success: false, message: 'Failed to edit subcategory' };
  };

  export const getSubCategoryApi = async (dispatch, expenseId) => {
    try {
      const response = await dispatch(fetchAsyncGetSubCategory(expenseId));
      if (response.payload) {
        return { success: true, data: response.payload || [] };
      }
    } catch (error) {
      console.error('Error fetching subcategories:', error);
      return { success: false, message: 'Error fetching subcategories' };
    }
  
    return { success: false, message: 'Failed to fetch subcategories' };
  };


  export const createMinorSubCategoryApi = async (dispatch, optionId, category,expenseType) => {
    try {
      const res = await dispatch(fetchAsyncCreateMinorSubCategory({ id: optionId, category, expenseType }));
      if (res.payload && res.payload.val) {
        return {
          success: true,
          data: {
            id: res.payload._id,
            label: res.payload.lab,
            value: res.payload.val,
            expenseType: res.payload?.expTyp,
            ...res.payload,
          },
        };
      }
    } catch (error) {
      return { success: false, message: 'Error creating minor subcategory' };
    }
    return { success: false, message: 'Failed to create minor subcategory' };
  };

  export const deleteMinorSubCategoryApi = async (dispatch, id) => {
    try {
      const res = await dispatch(fetchAsyncDeleteMinorSubCategory(id));
      
      if (res.payload && res.payload.val) {
        return { success: true, value: res.payload.val };
      }
    } catch (error) {
      return { success: false, message: 'Error deleting minor subcategory' };
    }
    return { success: false, message: 'Failed to delete minor subcategory' };
  };

  export const editMinorSubCategoryApi = async (dispatch,_id, newValue,expenseType) => {
    try {
      const res = await dispatch(fetchAsyncEditMinorSubCategory({
        id:_id,
        newData: {
          optionValue: newValue,
          expenseType,
        },
      }));
  
      if (res.payload && res.payload.val) {
        return { success: true, id: _id };
      }
    } catch (error) {
      return { success: false, message: 'Error editing minor subcategory' };
    }
    return { success: false, message: 'Failed to edit minor subcategory' };
  };
  
  export const getMinorSubCategoryApi = async (dispatch, expenseId) => {
    try {
      const response = await dispatch(fetchAsyncGetMinorSubCategory(expenseId));
      if (response.payload) {
        return { success: true, data: response.payload || [] };
      }
    } catch (error) {
      console.error('Error fetching minor subcategories:', error);
      return { success: false, message: 'Error fetching minor subcategories' };
    }
  
    return { success: false, message: 'Failed to fetch minor subcategories' };
  };